import React from 'react';
const SNAKKER_LOGO = 'https://cdn.magicpatterns.com/uploads/1NLDSzAUdy3Ski7VDDHkZA/image.png';
type SnakkerMarkProps = {
  tone?: 'paper' | 'accent';
  size?: 'sm' | 'lg';
  /** Show the "Thoughts-material" qualifier beside the logo. */
  showLabel?: boolean;
  className?: string;
};

/** Snakker logo — appears on every slide so authorship is never in doubt. */
export function SnakkerMark({
  tone = 'paper',
  size = 'sm',
  showLabel = true,
  className = ''
}: SnakkerMarkProps) {
  const accent = tone === 'accent';
  return <span className={`flex items-center gap-[0.7vw] ${className}`} data-id="element-71" data-mp="ql9rz4gp7p6b">
      <img src={SNAKKER_LOGO} alt="Snakker" className={['w-auto object-contain', size === 'lg' ? 'h-[clamp(26px,3.2vw,54px)]' : 'h-[clamp(14px,1.7vw,28px)]', accent ? 'rounded-md bg-white px-[0.5vw] py-[0.4vh]' : ''].join(' ')} data-id="element-72" data-mp="15h99t6tm13on" />
      {showLabel && <span className={['text-[clamp(8px,0.85vw,13px)] font-semibold uppercase tracking-[0.14em]', accent ? 'text-white/75' : 'text-gapAccent'].join(' ')} data-id="element-73" data-mp="2bz5vidkbx48l">
          Thoughts-material
        </span>}
    </span>;
}